<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <form @submit.prevent="subimtData()">
      <!--begin::Body-->
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">وصف مختصر: <span class="text-danger">*</span></label>
            <input type="text" v-model="title" class="form-control">
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">كود الخصم: <span class="text-danger">*</span></label>
            <input type="text" v-model="code" class="form-control">
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">نوع الخصم: <span class="text-danger">*</span></label>
            <select v-model="discountType" class="form-control">
              <option value="percentage">نسبة مئوية</option>
              <option value="fixed">قيمة ثابتة</option>
            </select>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">قيمة الخصم: <span class="text-danger">*</span></label>
            <input type="number" v-model="amount" class="form-control">
          </div>
        </div>

        <!-- Category & Sub-category -->
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">تطبيق الكوبون على: <span class="text-danger">*</span></label>
            <select v-model="category" class="form-control" @change="onCategoryChange">
              <option value="all">الكل</option>
              <option value="properties">العقارات</option>
              <option value="maintenance">الصيانة</option>
              <option value="lawyer">اطلب محاميك</option>
              <option value="photos">طلبات التصوير</option>
              <option value="adLicense">طلب اصدار ترخيص اعلاني</option>
              <option value="propertyDocs">توثيق عقد</option>
              <option value="userPackages">باقات الصيانة</option>
            </select>
          </div>
          <div v-if="category === 'properties'" class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">الغرض من العقار:</label>
            <select v-model="propertyPurpose" class="form-control">
              <option value="all">الكل</option>
              <option v-for="(val, key) in purposeChoices" :key="key" :value="key">{{ val }}</option>
            </select>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">الحد الاقصى للإستخدام للعميل الواحد (إن وجد):</label>
            <input type="number" v-model="maxUserUsing" class="form-control">
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">الحد الاقصى للإستخدام (إن وجد):</label>
            <input type="number" v-model="maxUsing" class="form-control">
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">تاريخ الإنتهاء (إن وجد):</label>
            <input type="date" v-model="expireDate" class="form-control">
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">الحالة:</label>
            <select v-model="isActive" class="form-control">
              <option :value="true">نشط</option>
              <option :value="false">غير نشط</option>
            </select>
          </div>
        </div>
      </div>
      <!--end::Body-->
      <!--begin::Footer-->
      <div class="card-footer">
        <div class="row">
          <div class="col text-end">
            <button v-if="!formLoader" type="submit" class="btn btn-success">ارسل</button>
            <loader v-if="formLoader" />
          </div>
        </div>
      </div>
      <!--end::Footer-->
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import { toast } from '@/helpers/tools';

export default {
  name: 'CouponsForm',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      title: '',
      code: '',
      discountType: 'percentage',
      amount: 0,
      expireDate: null,
      maxUserUsing: 0,
      maxUsing: 0,
      isActive: true,
      category: 'all',
      propertyPurpose: 'all',
      purposeChoices: {},
    }
  },
  methods: {
    subimtData(){
      this.formLoader = true;
      this.hasError = false;
      this.hasSucess = false;
      
      if(!this.title || this.title.trim() == '' || !this.code || this.code.trim() == '' || !this.amount){
        this.message = 'يجب ادخال الحقول الإجبارية';
        this.errorNumber = 0;
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
        return false;
      }
      let payload = {
        title: this.title,
        code: this.code.trim(),
        discountType: this.discountType,
        amount: this.amount,
        expireDate: this.expireDate || null,
        maxUserUsing: this.maxUserUsing,
        maxUsing: this.maxUsing,
        isActive: this.isActive,
        category: this.category,
        propertyPurpose: (this.category === 'properties') ? this.propertyPurpose : 'all',
      }
      let api = null;
      if(this.dataRow)
        api = this.$http.put(`/api/admin/coupons/update/${this.dataRow.id}`, payload);
      else
        api = this.$http.post('/api/admin/coupons/create', payload);
      api.then(({data}) => {
        if(!this.dataRow){
          toast('تمت الإضافة بنجاح', 'success');
          this.$router.replace('/coupons').catch(() => {});
        }else{
          this.message = 'تم التعديل بنجاح';
          this.hasSucess = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
    loadPurposeChoices() {
      this.$http.get('/api/admin/coupons/list?page=1').then(({ data }) => {
        if (data.propertyPurposeChoices) this.purposeChoices = data.propertyPurposeChoices;
      }).catch(() => {});
    },
    onCategoryChange() {
      if (this.category !== 'properties') this.propertyPurpose = 'all';
    },
  },
  created(){
    this.loadPurposeChoices();
    if(this.dataRow){
      this.title = this.dataRow.title;
      this.code = this.dataRow.code;
      this.discountType = this.dataRow.discountType;
      this.amount = this.dataRow.amount;
      this.expireDate = this.dataRow.expireDate ? String(this.dataRow.expireDate).split('T')[0] : null;
      this.maxUserUsing = this.dataRow.maxUserUsing;
      this.maxUsing = this.dataRow.maxUsing;
      this.isActive = this.dataRow.isActive;
      this.category = this.dataRow.category ?? 'all';
      this.propertyPurpose = this.dataRow.propertyPurpose ?? 'all';
    }
  }
}
</script>
